import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-performanceTypeShape",
  "use": "svg-icon-performanceTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-performanceTypeShape\"><g fill-rule=\"evenodd\"><path d=\"M0 7v2l5-3V4z\" /><path d=\"M0 9l5 3v-2L0 7zm11 1v2l5-3V7z\" /><path d=\"M11 6l5 3V7l-5-3zM8 2L6 14h2l2-12z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol